(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
  this.header.classList.add('shopify-section-header-sticky');
}

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rockeron-agile-route"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initProfiles = (root = document) => {
      root.querySelectorAll('[data-rar-profile]:not([data-rar-ready])').forEach((profile) => {
        profile.setAttribute('data-rar-ready', 'true');

        const path = profile.querySelector('[data-profile-motion]');
        const marker = profile.querySelector('[data-profile-marker]');
        const landmarks = Array.from(profile.querySelectorAll('[data-profile-landmark]'));
        const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        if (!path || !marker) return;

        const totalLength = path.getTotalLength();
        const setMarker = (progress) => {
          const point = path.getPointAtLength(totalLength * progress);
          marker.setAttribute('cx', point.x.toFixed(2));
          marker.setAttribute('cy', point.y.toFixed(2));
        };

        if (prefersReducedMotion) {
          setMarker(1);
          profile.classList.add('is-visible', 'is-complete');
          landmarks.forEach((landmark) => landmark.classList.add('is-visible'));
          return;
        }

        profile.classList.add('is-animated');
        setMarker(0);

        let started = false;
        const startProfile = () => {
          if (started) return;
          started = true;
          profile.classList.add('is-visible');

          const duration = 2400;
          const startedAt = performance.now();
          const revealAt = [0.08, 0.48, 0.88];

          const drawFrame = (now) => {
            const linearProgress = Math.min((now - startedAt) / duration, 1);
            const easedProgress = 1 - Math.pow(1 - linearProgress, 3);
            setMarker(easedProgress);

            landmarks.forEach((landmark, index) => {
              if (linearProgress >= revealAt[index]) landmark.classList.add('is-visible');
            });

            if (linearProgress < 1) {
              window.requestAnimationFrame(drawFrame);
            } else {
              profile.classList.add('is-complete');
            }
          };

          window.requestAnimationFrame(drawFrame);
        };

        if (!('IntersectionObserver' in window)) {
          startProfile();
          return;
        }

        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              startProfile();
              observer.unobserve(profile);
            });
          },
          { threshold: 0.28 }
        );

        observer.observe(profile);
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initProfiles());
    } else {
      initProfiles();
    }

    document.addEventListener('shopify:section:load', (event) => initProfiles(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rockeron-mini-product-page-v2"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (scope = document) => {
      scope.querySelectorAll('[data-rmp2]').forEach((root) => {
        if (root.dataset.rmp2Ready === 'true') return;
        root.dataset.rmp2Ready = 'true';
        const ballCopy = root.querySelector('[data-rmp2-ball-copy]');
        const price = root.querySelector('[data-rmp2-price]');
        const form = root.querySelector('.rmp2__form');
        const button = root.querySelector('.rmp2__add');
        const buttonLabel = root.querySelector('[data-rmp2-add-label]');
        const includedMedia = root.querySelector('[data-rmp2-support-kind]');
        const supportTitles = root.querySelectorAll('[data-rmp2-support-title], [data-rmp2-support-list-title]');
        const supportDescription = root.querySelector('[data-rmp2-support-description]');
        const ultraLink = root.querySelector('[data-rmp2-ultra-link]');
        const ultraPrice = root.querySelector('[data-rmp2-ultra-price]');
        const sticky = root.querySelector('[data-rmp2-sticky]');
        const stickyVariant = root.querySelector('[data-rmp2-sticky-variant]');
        const stickyPrice = root.querySelector('[data-rmp2-sticky-price]');
        const stickyAdd = root.querySelector('[data-rmp2-sticky-add]');
        const stickyLabel = root.querySelector('[data-rmp2-sticky-label]');
        root.querySelectorAll('.rmp2__variant > input').forEach((radio) => {
          radio.addEventListener('change', () => {
            if (!radio.checked) return;
            price.textContent = radio.dataset.priceFormatted || '';
            root.querySelectorAll('.rmp2__variant').forEach((label) => label.classList.remove('is-selected'));
            radio.closest('.rmp2__variant')?.classList.add('is-selected');
            const available = radio.dataset.available === 'true';
            button.disabled = !available;
            buttonLabel.textContent = available ? buttonLabel.dataset.addToCart : buttonLabel.dataset.soldOut;
            supportTitles.forEach((supportTitle) => {
              supportTitle.textContent = radio.dataset.supportTitle || '';
            });
            if (supportDescription) supportDescription.textContent = radio.dataset.supportDescription || '';
            if (ballCopy) ballCopy.textContent = radio.dataset.ballCopy || '';
            if (includedMedia) includedMedia.dataset.rmp2SupportKind = radio.dataset.supportKind || '';
            if (ultraLink && radio.dataset.ultraUrl) ultraLink.href = radio.dataset.ultraUrl;
            if (ultraPrice) ultraPrice.textContent = radio.dataset.ultraPrice || '';
            if (stickyVariant) stickyVariant.textContent = radio.closest('.rmp2__variant')?.querySelector('.rmp2__variant-copy > strong')?.textContent || '';
            if (stickyPrice) stickyPrice.textContent = radio.dataset.priceFormatted || '';
            if (stickyAdd) stickyAdd.disabled = !available;
            if (stickyLabel) stickyLabel.textContent = available ? stickyLabel.dataset.addToCart : stickyLabel.dataset.soldOut;
            const url = new URL(window.location.href);
            url.searchParams.set('variant', radio.value);
            window.history.replaceState({}, '', url);
          });
        });
        if (sticky && button) {
          const syncSticky = () => {
            sticky.hidden = button.getBoundingClientRect().bottom >= 0;
          };
          window.addEventListener('scroll', syncSticky, { passive: true });
          window.addEventListener('resize', syncSticky);
          stickyAdd?.addEventListener('click', () => {
            if (!button.disabled) form?.requestSubmit();
          });
          syncSticky();
        }
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
    else init();
    document.addEventListener('shopify:section:load', (event) => init(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rockeron-modular-product-page"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (scope = document) => {
      scope.querySelectorAll('[data-rmp]').forEach((root) => {
        if (root.dataset.rmpReady === 'true') return;
        root.dataset.rmpReady = 'true';
        const input = root.querySelector('[data-rmp-variant-input]');
        const price = root.querySelector('[data-rmp-price]');
        root.querySelectorAll('.rmp__variant input').forEach((radio) => {
          radio.addEventListener('change', () => {
            if (!radio.checked) return;
            input.value = radio.value;
            price.textContent = radio.dataset.priceFormatted || '';
            root.querySelectorAll('.rmp__variant').forEach((label) => label.classList.remove('is-selected'));
            radio.closest('.rmp__variant')?.classList.add('is-selected');
            const url = new URL(window.location.href);
            url.searchParams.set('variant', radio.value);
            window.history.replaceState({}, '', url);
          });
        });
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
    else init();
    document.addEventListener('shopify:section:load', (event) => init(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rockeron-road-to-sky"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initProfiles = (root = document) => {
      root.querySelectorAll('[data-rrs-profile]:not([data-rrs-ready])').forEach((profile) => {
        profile.setAttribute('data-rrs-ready', 'true');

        const path = profile.querySelector('[data-profile-motion]');
        const marker = profile.querySelector('[data-profile-marker]');
        const landmarks = Array.from(profile.querySelectorAll('[data-profile-landmark]'));
        const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        if (!path || !marker) return;

        const totalLength = path.getTotalLength();
        const setMarker = (progress) => {
          const point = path.getPointAtLength(totalLength * progress);
          marker.setAttribute('cx', point.x.toFixed(2));
          marker.setAttribute('cy', point.y.toFixed(2));
        };

        if (prefersReducedMotion) {
          setMarker(1);
          profile.classList.add('is-visible', 'is-complete');
          landmarks.forEach((landmark) => landmark.classList.add('is-visible'));
          return;
        }

        profile.classList.add('is-animated');
        setMarker(0);

        let started = false;
        const startProfile = () => {
          if (started) return;
          started = true;
          profile.classList.add('is-visible');

          const duration = 2400;
          const startedAt = performance.now();
          const revealAt = [0.08, 0.32, 0.88];

          const drawFrame = (now) => {
            const linearProgress = Math.min((now - startedAt) / duration, 1);
            const easedProgress = 1 - Math.pow(1 - linearProgress, 3);
            setMarker(easedProgress);

            landmarks.forEach((landmark, index) => {
              if (linearProgress >= revealAt[index]) landmark.classList.add('is-visible');
            });

            if (linearProgress < 1) {
              window.requestAnimationFrame(drawFrame);
            } else {
              profile.classList.add('is-complete');
            }
          };

          window.requestAnimationFrame(drawFrame);
        };

        if (!('IntersectionObserver' in window)) {
          startProfile();
          return;
        }

        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              startProfile();
              observer.unobserve(profile);
            });
          },
          { threshold: 0.28 }
        );

        observer.observe(profile);
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initProfiles());
    } else {
      initProfiles();
    }

    document.addEventListener('shopify:section:load', (event) => initProfiles(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rockeron-setup-finder"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const normalise = (value) => String(value || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();

    const track = (name, data = {}) => {
      const payload = { ...data, page: window.location.pathname };
      if (window.Shopify?.analytics?.publish) {
        try { window.Shopify.analytics.publish(`rockeron:${name}`, payload); } catch (error) {}
      }
      if (typeof window.gtag === 'function') {
        window.gtag('event', `rockeron_${name}`, payload);
      } else if (Array.isArray(window.dataLayer)) {
        window.dataLayer.push({ event: `rockeron_${name}`, ...payload });
      }
    };

    const initFinder = (root) => {
      if (!root || root.dataset.finderReady === 'true') return;
      const configNode = root.querySelector('[data-finder-config]');
      if (!configNode) return;

      let config;
      try { config = JSON.parse(configNode.textContent); } catch (error) { return; }
      root.dataset.finderReady = 'true';

      const labels = config.labels;
      const stageNode = root.querySelector('[data-finder-stage]');
      const headingNode = root.querySelector('[data-finder-heading]');
      const introNode = root.querySelector('[data-finder-intro]');
      const progressSteps = Array.from(root.querySelectorAll('[data-progress-step]'));
      const footerNode = root.querySelector('[data-finder-footer]');
      const missingNode = root.querySelector('[data-finder-missing]');
      const backNode = root.querySelector('[data-finder-back]');
      const missingLink = root.querySelector('[data-finder-missing] a');
      const state = { step: 0, trainerId: null, bike: null, model: null, balls: null };
      const isPage = root.classList.contains('rosf--page');
      const initialParams = new URLSearchParams(window.location.search);
      let startedTracked = false;
      let noResultTracked = false;

      if (isPage) {
        const trainerParam = initialParams.get('trainer');
        const bikeParam = initialParams.get('setup');
        if (trainerParam && config.trainers.some((trainer) => trainer.id === trainerParam)) {
          state.trainerId = trainerParam;
          state.step = 1;
        }
        if (state.trainerId && ['standard', 'zwift'].includes(bikeParam)) {
          state.bike = bikeParam;
          state.model = 'ultra';
          state.balls = 'balanced';
          state.step = 1;
        }
      }

      const syncUrl = () => {
        if (!isPage) return;
        const url = new URL(window.location.href);
        const values = { trainer: state.trainerId, setup: state.bike, system: state.model };
        Object.entries(values).forEach(([key, value]) => {
          if (value) url.searchParams.set(key, value);
          else url.searchParams.delete(key);
        });
        window.history.replaceState({}, '', url);
      };

      const escapeHtml = (value) => {
        const element = document.createElement('div');
        element.textContent = String(value ?? '');
        return element.innerHTML;
      };

      const selectedTrainer = () => config.trainers.find((trainer) => trainer.id === state.trainerId) || null;
      const selectedProduct = () => {
        const trainer = selectedTrainer();
        if (!trainer || !state.model || !state.bike) return null;
        const bikeKey = state.bike === 'zwift' ? 'Zwift' : 'Standard';
        return trainer[`${state.model}${bikeKey}`] || null;
      };

      const ballMatches = (value, balls) => {
        const text = normalise(value);
        if (balls === 'balanced') return text.includes('balanced') || text.includes('mix');
        if (balls === 'essential') return text.includes('essential') || text.includes('stable');
        if (balls === 'performance') return text.includes('performance') || text.includes('full');
        if (balls === 'none') return text.includes('no ball') || text.includes('without ball') || text === 'none';
        if (balls === 'basic') return text.includes('basic');
        return false;
      };

      const optionIndex = (product, matcher) => (product?.optionNames || []).findIndex((name) => matcher(normalise(name)));

      const resolveVariant = (product, balls, bike = state.bike) => {
        if (!product) return null;

        const skuTokens = {
          balanced: ['bal'],
          performance: ['perf'],
          essential: ['ess'],
          basic: ['basic']
        };
        const variants = product.variants || [];
        const hasBikeSpecificSkus = variants.some((variant) => {
          const sku = normalise(variant.sku);
          return sku.includes('zwift') || sku.includes('bike');
        });
        const bikeToken = bike === 'zwift' ? 'zwift' : 'bike';
        const wantedSkuTokens = skuTokens[balls] || [];
        const skuVariant = variants.find((variant) => {
          const sku = normalise(variant.sku);
          const matchesSet = wantedSkuTokens.some((token) => sku.includes(token));
          const matchesBike = !hasBikeSpecificSkus || sku.includes(bikeToken);
          return matchesSet && matchesBike;
        });
        if (skuVariant) return skuVariant;

        const ballIndex = optionIndex(product, (name) => name.includes('ball') || name.includes('motion') || name.includes('ride feel') || name.includes('configuration') || name.includes('setup'));

        return variants.find((variant) => {
          const sku = normalise(variant.sku);
          const matchesBike = !hasBikeSpecificSkus || sku.includes(bikeToken);
          const ballValue = ballIndex >= 0 ? variant.options[ballIndex] : variant.title;
          return matchesBike && ballMatches(ballValue, balls);
        }) || null;
      };

      const openSelectedProduct = () => {
        const trainer = selectedTrainer();
        const product = selectedProduct();
        const variant = resolveVariant(product, state.balls) || (product?.variants || [])[0];
        if (!product?.url || !variant) {
          if (!noResultTracked) {
            track('finder_no_result', { trainer: trainer?.name || '', setup: state.bike || '', system: state.model || '' });
            noResultTracked = true;
          }
          return;
        }
        syncUrl();
        const resultUrl = new URL(product.url, window.location.origin);
        resultUrl.searchParams.set('variant', variant.id);
        resultUrl.searchParams.set('finder', '1');
        resultUrl.searchParams.set('trainer', trainer?.name || '');
        resultUrl.searchParams.set('setup', state.bike || '');
        resultUrl.searchParams.set('system', state.model || '');
        track('finder_completed', { trainer: trainer?.name || '', setup: state.bike || '', system: state.model || '', product: product.handle || '' });
        track('finder_product_clicked', { trainer: trainer?.name || '', setup: state.bike || '', system: state.model || '', product: product.handle || '' });
        window.location.assign(resultUrl.toString());
      };

      const card = ({ title, text, kicker, image, disabled, value, group, kind = '' }) => `
        <button class="rosf__choice${kind ? ` rosf__choice--${escapeHtml(kind)}` : ''}" type="button" data-choice-group="${escapeHtml(group)}" data-choice-value="${escapeHtml(value)}" ${disabled ? 'disabled' : ''}>
          ${image ? (kind === 'trainer' ? `<span class="rosf__trainer-media"><img class="rosf__choice-image" src="${escapeHtml(image)}" alt="" loading="lazy"></span>` : `<img class="rosf__choice-image" src="${escapeHtml(image)}" alt="" loading="lazy"><span class="rosf__choice-shade"></span>`) : ''}
          <span class="rosf__choice-content">
            ${kicker ? `<span class="rosf__choice-kicker">${escapeHtml(kicker)}</span>` : ''}
            <span class="rosf__choice-title">${escapeHtml(title)}</span>
            ${text ? `<span class="rosf__choice-text">${escapeHtml(text)}</span>` : ''}
          </span>
          ${disabled ? '' : '<span class="rosf__choice-arrow" aria-hidden="true">→</span>'}
        </button>`;

      const setHeader = (heading, intro) => {
        headingNode.textContent = heading;
        introNode.textContent = intro;
        progressSteps.forEach((stepNode, index) => {
          stepNode.classList.toggle('is-active', index === state.step);
          stepNode.classList.toggle('is-complete', index < state.step);
          if (index === state.step) stepNode.setAttribute('aria-current', 'step');
          else stepNode.removeAttribute('aria-current');
        });
        footerNode.hidden = state.step === 0;
      };

      const bindChoices = () => {
        stageNode.querySelectorAll('[data-choice-group]').forEach((button) => {
          button.addEventListener('click', () => {
            const group = button.dataset.choiceGroup;
            const value = button.dataset.choiceValue;
            if (group === 'trainer') {
              state.trainerId = value;
              state.bike = null;
              state.model = null;
              state.step = 1;
              if (!startedTracked) {
                track('finder_started', { source: isPage ? 'page' : 'embedded' });
                startedTracked = true;
              }
              track('finder_trainer_selected', { trainer: selectedTrainer()?.name || '' });
            }
            if (group === 'bike') {
              state.bike = value;
              state.model = 'ultra';
              state.balls = 'balanced';
              track('finder_setup_selected', { trainer: selectedTrainer()?.name || '', setup: value });
              openSelectedProduct();
              return;
            }
            syncUrl();
            render();
          });
        });
      };

      const renderTrainers = () => {
        setHeader(labels.trainerHeading, labels.trainerText);
        stageNode.innerHTML = `<div class="rosf__grid rosf__grid--four">${config.trainers.map((trainer) => {
          const disabled = !trainer.ultraStandard && !trainer.ultraZwift;
          return card({
            title: trainer.name,
            text: trainer.text,
            kicker: '',
            image: trainer.image,
            disabled,
            value: trainer.id,
            group: 'trainer',
            kind: 'trainer'
          });
        }).join('')}</div>`;
      };

      const renderBikes = () => {
        setHeader(labels.bikeHeading, labels.bikeText);
        stageNode.innerHTML = `<div class="rosf__grid">
          ${card({ title: labels.standardBike, text: labels.standardBikeText, image: config.bikeImages?.standard, value: 'standard', group: 'bike', kind: 'bike' })}
          ${card({ title: labels.zwiftRide, text: labels.zwiftRideText, image: config.bikeImages?.zwift, value: 'zwift', group: 'bike', kind: 'bike' })}
        </div>`;
      };

      const render = () => {
        if (state.step === 0) renderTrainers();
        if (state.step === 1) renderBikes();
        if (missingNode) missingNode.hidden = state.step !== 0;
        bindChoices();
      };

      backNode.addEventListener('click', () => {
        state.step = Math.max(0, state.step - 1);
        state.model = null;
        state.balls = null;
        if (state.step < 1) state.bike = null;
        if (state.step === 0) state.trainerId = null;
        syncUrl();
        render();
      });

      missingLink?.addEventListener('click', () => {
        track('finder_no_result', {
          source: 'missing_trainer',
          trainer: selectedTrainer()?.name || '',
          setup: state.bike || ''
        });
      });

      if (isPage && state.trainerId && state.bike) {
        syncUrl();
        openSelectedProduct();
        return;
      }

      render();
    };

    const initAll = (scope = document) => scope.querySelectorAll('[data-rockeron-finder]').forEach(initFinder);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll());
    else initAll();
    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
